import { SVGProps } from 'react';

const ThumbScaleSmallKindUpReducedFalse = (props: SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_3_188)">
            <path
                d="M4.66665 14.6667V7.33334M1.33331 8.66668V13.3333C1.33331 14.0697 1.93027 14.6667 2.66665 14.6667H11.6175C12.6046 14.6667 13.4441 13.9465 13.5942 12.9708L14.3122 8.30412C14.4986 7.09261 13.5612 6.00001 12.3354 6.00001H9.99998C9.63179 6.00001 9.33331 5.70153 9.33331 5.33334V2.97724C9.33331 2.06934 8.59732 1.33334 7.68942 1.33334C7.47287 1.33334 7.27663 1.46087 7.18868 1.65876L4.84261 6.93744C4.7356 7.17819 4.49686 7.33334 4.2334 7.33334H2.66665C1.93027 7.33334 1.33331 7.9303 1.33331 8.66668Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeWidth={1.33333}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_3_188">
                <rect width={16} height={16} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export default ThumbScaleSmallKindUpReducedFalse;
